"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityCacheHandler = void 0;
var util_1 = require("../util");
function EntityCacheHandler(TTL) {
    var _this = this;
    var cache = [];
    var queueable = util_1.Queueable('remove', 'removeMany');
    return {
        get: function (id) {
            var c = cache.find(function (e) { return e.entity._id === id; });
            return c ? JSON.parse(JSON.stringify(c.entity)) : undefined;
        },
        getAll: function () {
            return JSON.parse(JSON.stringify(cache.map(function (e) { return e.entity; })));
        },
        getMany: function (ids) {
            var entries = [];
            return JSON.parse(JSON.stringify(cache.filter(function (e) { return ids.includes(e.entity._id); }).map(function (e) { return e.entity; })));
        },
        set: function (entity) {
            for (var i in cache) {
                if (cache[i].entity._id === entity._id) {
                    cache[i] = {
                        expAt: Date.now() + TTL,
                        entity: JSON.parse(JSON.stringify(entity)),
                    };
                    return;
                }
            }
            cache.push({
                expAt: Date.now() + TTL,
                entity: entity,
            });
        },
        remove: function (id) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, queueable.exec('remove', 'free_one_by_one', function () { return __awaiter(_this, void 0, void 0, function () {
                            var i;
                            return __generator(this, function (_a) {
                                for (i = 0; i < cache.length; i = i + 1) {
                                    if (cache[i].entity._id === id) {
                                        cache.splice(i, 1);
                                        break;
                                    }
                                }
                                return [2];
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); },
        removeMany: function (ids) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, queueable.exec('removeMany', 'free_one_by_one', function () { return __awaiter(_this, void 0, void 0, function () {
                                var removeIndexes, i, i;
                                return __generator(this, function (_a) {
                                    removeIndexes = [];
                                    for (i = 0; i < cache.length; i = i + 1) {
                                        if (ids.includes(cache[i].entity._id)) {
                                            removeIndexes.push(i);
                                        }
                                    }
                                    for (i = removeIndexes.length - 1; i > -1; i = i - 1) {
                                        cache.splice(removeIndexes[i], 1);
                                    }
                                    return [2];
                                });
                            }); })];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            });
        },
        clear: function () {
            while (cache.length > 0) {
                cache.pop();
            }
        },
        clearExpired: function () {
            var clearIds = [];
            for (var i = 0; i < cache.length; i = i + 1) {
                if (cache[i].expAt > Date.now()) {
                    clearIds.push(i);
                }
            }
            for (var i in clearIds) {
                var id = clearIds[i];
                cache.splice(id, 1);
            }
        },
        find: function (query) {
            var output = [];
            for (var i in cache) {
                if (query(cache[i].entity)) {
                    output.push(JSON.parse(JSON.stringify(cache[i].entity)));
                }
            }
            return JSON.parse(JSON.stringify(output));
        },
        findOne: function (query) {
            for (var i in cache) {
                if (query(cache[i].entity)) {
                    return JSON.parse(JSON.stringify(cache[i].entity));
                }
            }
        },
    };
}
exports.EntityCacheHandler = EntityCacheHandler;
//# sourceMappingURL=handler.js.map